import { useMemo, useState } from 'react';
import { ViewProps } from 'react-native';

/**
 * Hover state for desktop web. Spread `hoverHandlers` onto any View/Pressable/Box:
 *
 *   const { hovered, hoverHandlers } = useHover();
 *   <Pressable {...hoverHandlers}>...
 *
 * Detects hover via the DOM mouse events react-native-web passes through — deliberately NOT via
 * Pressable's onHoverIn/onHoverOut: RNW Pressables use "contained" hover, so a nested Pressable
 * child (e.g. the currency toggle inside a hover wrapper) cancels an ancestor Pressable's hover.
 * The mouse props are missing from RN's types (hence the cast) and are ignored on native, where
 * `hovered` simply stays false.
 */
export const useHover = () => {
    const [hovered, setHovered] = useState(false);

    const hoverHandlers = useMemo(
        () =>
            ({
                onMouseEnter: () => setHovered(true),
                onMouseLeave: () => setHovered(false),
            } as ViewProps),
        []
    );

    return { hovered, hoverHandlers };
};
